<template>
    <v-card>
        <v-card-text>
            <table x:str border="0" cellpadding="2" style="border-collapse: collapse; margin-left: 0; margin-right: 2"
                height="450" width="730">
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <b>
                            <font face="Arial" color="#666666" size="4">DOCUMENTOS
                                DEL SGI MÁS UTILIZADOS POR SST</font>
                        </b>
                    </td>
                </tr>
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <img border="0" src="../../../public/images/DOCSGI.jpg" width="868" height="160">
                    </td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;ASIGNACIÓN DE FUNCIONES</font>
                    </td>
                </tr>
                <tr v-for="item in asignaciones" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;FORMULARIOS</font>
                    </td>
                </tr>
                <tr v-for="item in formularios" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;MANUALES</font>
                    </td>
                </tr>
                <tr v-for="item in manuales" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;PROCEDIMIENTOS</font>
                    </td>
                </tr>
                <tr v-for="item in procedimientos" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;INSTRUCCIONES</font>
                    </td>
                </tr>
                <tr v-for="item in instrucciones" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
            </table>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "ListaInstrucciones",
    data() {
        return {
            asignaciones: [
                { codigo: "EI 008-14", descripcion: "Gerente de fabricación" },
                { codigo: "EI 008-21", descripcion: "Responsable de planificación de ing. de producto y de fabricación" },
                { codigo: "EI 008-12", descripcion: "Responsable de proyecto (mecánico y eléctrico - Ing. de producto)" },
                { codigo: "EI 008-13", descripcion: "Responsable de proyecto (mecánico y eléctrico - Ing. de producto)" },
                { codigo: "EI 008-23", descripcion: "Auxiliar de gestión de materiales, control de gestión y seguimiento de OT." },
                { codigo: "EI 008-71", descripcion: "Auxiliar de ingeniería de producto" }
            ],

            formularios: [
                { codigo: "EI 002", descripcion: "Política de la calidad, medio ambiente, y seguridad y salud ocupacional" },
                { codigo: "EI 004", descripcion: "Organigrama de Electroingeniería ICS SA" },
                { codigo: "EI 027", descripcion: "Planilla de control de documentos" },
                { codigo: "EI 057", descripcion: "Registro de autoinspección de procesos" },
                { codigo: "EI 062", descripcion: "Planilla de horas de ingeniería / ingeniería de producto" },
                { codigo: "EI 089", descripcion: "Registro de capacitación" },
                { codigo: "EI 112", descripcion: "Planilla de revisión / verificación / validación del diseño" },
                { codigo: "EI 128", descripcion: "Rendición de gastos de viaje" },
                { codigo: "EI 129", descripcion: "Rendición de fondos fijos transitorios" },
                { codigo: "EI 130", descripcion: "Asignación de mano de obra" }
            ],

            manuales: [
                { codigo: "EI 400", descripcion: "Manual de montaje y puesta en servicio - CEISA 90" },
                { codigo: "EI 401", descripcion: "Manual de montaje y puesta en servicio - Celda CEISA 21-SJ" },
                { codigo: "EI 402", descripcion: "Manual de montaje y puesta en servicio de salas prefabricadas de Hº Aº para uso eléctrico" },
                { codigo: "EI 403", descripcion: "Manual de montaje y puesta en servicio - CEISA 21-SF" },
                { codigo: "EI 404", descripcion: "Manual reducido del SGI" },
                { codigo: "EI 405", descripcion: "Legislación para subcontratistas" }
            ],

            procedimientos: [
                { codigo: "MP4.02.01", descripcion: "Elaboración, aprobación, distribución y control de los documentos del SGI" },
                { codigo: "MP7.03.01", descripcion: "Diseño y desarrollo" },
                { codigo: "MP7.04.01", descripcion: "Gestión de compras" },
                { codigo: "MP6.01.02", descripcion: "Gestión de riesgos y oportunidades" },
                { codigo: "MP8.03.01", descripcion: "Gestión de no conformidades" },
                { codigo: "MP8.05.01", descripcion: "Gestión de mejoras" },
                { codigo: "MP8.05.02", descripcion: "Acciones correctivas" }
            ],

            instrucciones: [
                { codigo: "MI7.03.01.01", descripcion: "Criterios generales para el diseño" },
                { codigo: "MI7.03.01.06", descripcion: "Sistema Internacional de Unidades (SI) y recomendaciones para el uso de sus múltiplos y de otras unidades" },
                { codigo: "MI8.04.02.11", descripcion: "Elaboración de estadísticas en el área ingeniería de producto" },
                { codigo: "MI4.02.01.01", descripcion: "Archivo general" },
                { codigo: "MI4.02.01.02", descripcion: "Sistema de back-up y almacenamiento de datos" },
                { codigo: "MI8.01.01.01", descripcion: "Guía para la gestión de la economía de la calidad, medio ambiente y SySO" }
            ]
        };
    }
};
</script>